import type { ScoringColumns } from '@library/types/scoring';
import type { TableColumn } from '@library/types/utils';

export const SCORING_HEADER_INFO: Array<TableColumn<ScoringColumns>> = [
  {
    column: 'player',
    essential: true,
    label: 'Player',
    sortEnabled: true
  },
  {
    column: 'duration',
    essential: true,
    label: 'Duration',
    sortEnabled: false
  },
  {
    column: 'team',
    essential: true,
    label: 'Team',
    sortEnabled: true
  },
  {
    column: 'description',
    essential: true,
    label: 'Opponent',
    sortEnabled: true
  },
  {
    column: 'id',
    essential: true,
    label: 'Projection ID',
    shortenedLabel: 'Proj ID',
    sortEnabled: true
  },
  {
    column: 'start_time',
    essential: true,
    label: 'Start Time',
    shortenedLabel: 'Start',
    sortEnabled: true
  },
  {
    column: 'status',
    essential: true,
    label: 'Game Status',
    shortenedLabel: 'Status',
    sortEnabled: true
  },
  {
    column: 'game_modes',
    essential: true,
    label: 'Game Modes',
    sortEnabled: false
  },
  {
    column: 'stat_type',
    essential: true,
    label: 'Stat Type',
    shortenedLabel: 'Stat',
    sortEnabled: true
  },
  {
    column: 'line_score',
    essential: true,
    label: 'Projection',
    shortenedLabel: 'Proj',
    sortEnabled: true
  },
  {
    column: 'scoreId',
    essential: true,
    label: 'Score ID',
    shortenedLabel: 'Score ID',
    sortEnabled: false
  },
  {
    column: 'score',
    essential: true,
    label: 'Actual',
    sortEnabled: false
  },
  {
    column: 'lastUpdated',
    essential: true,
    label: 'Updated at',
    shortenedLabel: 'Updated',
    sortEnabled: false
  },
  {
    column: 'is_off_board',
    essential: true,
    label: 'DNP',
    sortEnabled: false
  },
  {
    column: 'settled',
    essential: true,
    label: 'Is Final',
    sortEnabled: false
  },
  // {
  //   column: 'auto_finalize',
  //   essential: true,
  //   label: 'Auto Finalize',
  //   sortEnabled: false
  // },
  {
    column: 'kebab_menu',
    essential: true,
    label: '',
    sortEnabled: false
  }
];
